import { RestService, API, getPath } from './lib';
import getSearchServiceImpl from './search/searchServiceDiscovery';
import { SEARCH_SERVICE_TYPE } from 'constants/index';

class EntityRecordService extends RestService {
  get = (ids = {}, params = {}) => {
    this.validate(['id', 'displayId'], ids);
    return this.dispatch('ENTITY_RECORD_GET', ids, params);
  };

  getAll = (ids = {}, params = {}) => {
    this.validate(['id'], ids);
    return this.dispatch('ENTITY_RECORDS_LIST', ids, params);
  };

  count = (ids = {}, params = {}) => {
    delete params.sort_by;
    delete params.page_size;
    return this.dispatch('ENTITY_RECORDS_COUNT', ids, params);
  };

  put = (ids = {}, payload = {}, params = {}) => {
    this.validate(['id', 'displayId'], ids);
    return this.dispatch('ENTITY_RECORD_PUT', ids, params, payload);
  };

  create = (ids = {}, payload = {}, params = {}) => {
    this.validate(['id'], ids);
    return this.dispatch('ENTITY_RECORD_CREATE', ids, params, payload);
  };

  delete = (ids = {}, params = {}) => {
    this.validate(['id', 'displayId'], ids);
    return this.dispatch('ENTITY_RECORD_DELETE', ids, params);
  };

  search = (ids = {}, params = {}) => {
    return getSearchServiceImpl(SEARCH_SERVICE_TYPE.ENTITY_RECORD).search(ids, params);
  };

  bulk = (ids = {}, params = {}) => {
    this.validate(['id'], ids);
    const url = getPath(API.ENTITY_RECORDS_BULK, ids, params);
    return this.sendRequest(url, 'GET');
  };
}

export const entityRecordService = new EntityRecordService();
